import React from "react";
import { Link, useLocation } from "react-router-dom";
import { FaHome, FaSearch, FaShoppingCart, FaThLarge, FaUserCircle } from "react-icons/fa";
import { FiHeart, FiShoppingCart, FiUser } from "react-icons/fi";
import Logo from "../assets/logo.png"
export default function Header() {
    const location = useLocation();
    const wishlistCount = 0;
    const cartCount = 0;
    return (
        <>
            <header class="header desktop-header">
                <div class="logo"><a href="/"><img src={Logo}></img></a></div>
                <div class="search-bar"><input type="text" placeholder="Search products..." /><button><FaSearch color="white" size={16} /></button></div>
                <nav className="nav-icons" style={{ display: "flex", gap: "25px", alignItems: "center" }}>
                    <Link to="/signin" className={location.pathname === "/signin" ? "active" : ""} title="Account" style={{ color: "black" }}>
                        <FiUser size={22} />
                    </Link>
                    <Link to="/wishlist" className={location.pathname === "/wishlist" ? "active" : ""} title="Wishlist" style={{ color: "black", position: "relative" }}>
                        <FiHeart size={22} />
                        {wishlistCount > 0 && (
                            <span style={{ position: "absolute", top: "-12px", right: "-10px", background: "#e05da3", color: "white", borderRadius: "50%", padding: "2px 6px", fontSize: "12px", fontWeight: "600", }}>{wishlistCount}</span>
                        )}
                    </Link>
                    <Link to="/cart" className={location.pathname === "/cart" ? "active" : ""} title="Cart" style={{ color: "black", position: "relative" }}>
                        <FiShoppingCart size={22} />
                        {cartCount > 0 && (
                            <span style={{ position: "absolute", top: "-12px", right: "-10px", background: "#e05da3", color: "white", borderRadius: "50%", padding: "2px 6px", fontSize: "12px", fontWeight: "600", }}>{cartCount}</span>
                        )}
                    </Link>
                </nav>
            </header>
            <header class="mobile-top-header">
                <div class="mobile-logo"><a href="/">
                    <img src={Logo}></img>
                </a></div>
                <div class="mobile-cart">
                    {/* <Link to="/" className={location.pathname === "/categories" ? "active" : ""} style={{ color: "black", position: "relative" }}>
                        <FaSearch size={22} />
                    </Link> */}
                    <Link to="/cart" className={location.pathname === "/cart" ? "active" : ""} style={{ color: "black", position: "relative", marginLeft: "10px" }}>
                        <FaShoppingCart size={22} />
                        {cartCount > 0 && <span className="cart-count">{cartCount}</span>}
                    </Link>
                </div>
            </header>
            <nav class="bottom-nav mobile-header">
                <Link to="/" className={location.pathname === "/" ? "active" : ""}>
                    <FaHome size={22} />
                    <span>Home</span>
                </Link>
                <Link to="/categories" className={location.pathname === "/categories" ? "active" : ""}>
                    <FaSearch size={22} />
                    <span>Search</span>
                </Link>
                <Link to="/categories" className={location.pathname === "/categories" ? "active" : ""}>
                    <FaThLarge size={22} />
                    <span>Shop</span>
                </Link>
                <Link to="/cart" className={location.pathname === "/cart" ? "active" : ""}>
                    <FaShoppingCart size={22} />
                    {cartCount > 0 && <span className="cart-count">{cartCount}</span>}
                    <span>Cart</span>
                </Link>
                <Link to="/signin" className={location.pathname === "/signin" ? "active" : ""}>
                    <FaUserCircle size={22} />
                    <span>Account</span>
                </Link>
            </nav>
        </>
    );
}